module.exports = __webpack_public_path__ + "static/img/carousel_2.06b1f640.jpg";